module.exports = __webpack_public_path__ + "img/hair_front_female_updo_mask.0dec576c.png";